
export default {
  name: 'icon-status-flight',
};
